import { render } from "./Table.vue?vue&type=template&id=11cb96e0"
import script from "./Table.vue?vue&type=script&lang=js"
export * from "./Table.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/admin/ui/Components/Common/Table.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "11cb96e0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('11cb96e0', __exports__)) {
    api.reload('11cb96e0', __exports__)
  }
  
  module.hot.accept("./Table.vue?vue&type=template&id=11cb96e0", () => {
    api.rerender('11cb96e0', render)
  })

}


export default __exports__